import "core-js/modules/es6.array.map";
import "core-js/modules/es6.array.for-each";
import "core-js/modules/es6.array.filter";
import _isEmpty from "lodash/isEmpty";
import _isNil from "lodash/isNil";
import PropTypes from 'prop-types';
import React from 'react';
import { useDeprecatedPropsWarning } from '@nerdwallet/deprecate';
import QuickFacts, { QuickFactValue } from '@nerdwallet/react-quick-facts';
import { Body, Tooltip } from '@nerdwallet/currency';
import classNames from 'classnames';
import styles from './keto-product-card.module.less';

var KetoQuickFacts = function KetoQuickFacts(_ref) {
  var analytics = _ref.analytics,
      enableAnalytics = _ref.enableAnalytics,
      quickFacts = _ref.quickFacts;
  useDeprecatedPropsWarning({
    component: 'KetoQuickFacts',
    deprecatedProps: [{
      version: '6.9.0',
      deprecated: 'enableAnalytics',
      migration: 'Use analytics instead.'
    }],
    props: {
      enableAnalytics: enableAnalytics
    }
  });
  var quickFactComponents = [];
  var filteredQuickFacts = quickFacts.filter(function (quickFact) {
    return quickFact && !_isNil(quickFact.value);
  });

  if (_isEmpty(filteredQuickFacts)) {
    return null;
  }

  filteredQuickFacts.forEach(function (quickFact) {
    quickFactComponents.push( /*#__PURE__*/React.createElement("div", {
      key: "".concat(quickFact.id, "-value"),
      className: classNames(styles.driversRow)
    }, /*#__PURE__*/React.createElement(Body, {
      className: classNames([styles.cell, styles.label])
    }, quickFact.labelTooltip ? /*#__PURE__*/React.createElement(Tooltip, {
      id: quickFact.id,
      label: quickFact.label,
      content: /*#__PURE__*/React.createElement("span", {
        className: styles.tooltipContent
      }, quickFact.labelTooltip),
      title: "More information about ".concat(quickFact.label)
    }) : quickFact.label), /*#__PURE__*/React.createElement(Body, {
      className: classNames([styles.cell, styles.value])
    }, /*#__PURE__*/React.createElement(QuickFactValue, {
      analytics: analytics,
      enableAnalytics: enableAnalytics || !_isEmpty(analytics),
      quickFact: quickFact
    }))));
  });
  return quickFactComponents;
};

var KetoCardDrivers = function KetoCardDrivers(_ref2) {
  var analytics = _ref2.analytics,
      className = _ref2.className,
      drivers = _ref2.drivers,
      enableAnalytics = _ref2.enableAnalytics,
      wrapDrivers = _ref2.wrapDrivers;
  useDeprecatedPropsWarning({
    component: 'KetoQuickFacts',
    deprecatedProps: [{
      version: '6.9.0',
      deprecated: 'enableAnalytics',
      migration: 'Use analytics instead.'
    }],
    props: {
      enableAnalytics: enableAnalytics
    }
  });

  if (_isEmpty(drivers)) {
    return null;
  }

  return /*#__PURE__*/React.createElement("div", {
    className: className
  }, wrapDrivers ? /*#__PURE__*/React.createElement("div", {
    className: styles.wrappedDrivers
  }, drivers.map(function (driver) {
    return /*#__PURE__*/React.createElement(KetoQuickFacts, {
      analytics: analytics,
      enableAnalytics: enableAnalytics || !_isEmpty(analytics),
      key: driver.id,
      quickFacts: [driver]
    });
  })) : /*#__PURE__*/React.createElement(KetoQuickFacts, {
    analytics: analytics,
    enableAnalytics: enableAnalytics,
    quickFacts: drivers
  }));
};

KetoCardDrivers.propTypes = {
  analytics: PropTypes.shape({
    entityName: PropTypes.string
  }),
  className: PropTypes.string,
  drivers: PropTypes.arrayOf(PropTypes.shape(QuickFacts.PropTypes)),

  /** @deprecated A flag indicating to send analytics */
  enableAnalytics: PropTypes.bool,
  wrapDrivers: PropTypes.bool
};
KetoCardDrivers.defaultProps = {
  analytics: {},
  drivers: [],
  wrapDrivers: false
};
export default KetoCardDrivers;